/* template */
<template minapp="mpx" xlang="wxml"><es-layout :layout="(['header', 'footer'])" navbarTitle="选择国家或地区" :navbarClickLeft="(goBack)" :leftArrow="(true)" @scrolling="handleScroll" custom-main="custom-main" custom-navbar="custom-navbar" :scrollTop="(topHeight)" :scrollWithAnimation="(true)" ref="__mpx_ref_scroll_layout__" class="es-selectCountry"><div slot="header" class="page-header"><search-input @input="handleInput" placeholder="中文 / 英文" :showFocusBorder="(true)"/><div class="es-selectCountry__keyString" v-if="(!isSearch&&!isLoading)">{{copyKeyString}}</div><div class="es-selectCountry__tabView" v-if="(!isSearch&&!isLoading)"><div class="es-selectCountry__tab"><mpx-view v-for="(tabItem, index) in (tabData)" :class='("es-selectCountry__tabItem "+(copyKeyString == tabItem ? "es-selectCountry__active" : ""))' @tap="onChange(tabItem)">{{tabItem}}</mpx-view></div></div></div><div id="country_list" class="es-selectCountry__list"><div v-for="(item, index) in (isSearch?searchRes:innnerGoupCountry)" :id="('block' + item.keyString)"><mpx-view v-for="(keyItem, index) in (item.data)" :style="[(mright)] | transRpxStyle" @tap="selectCountry(keyItem)" class="es-selectCountry__list-item"><div class="es-selectCountry__country_name"><div class="es-selectCountry__country_name_cn">{{keyItem.country_name_cn}}</div><div class="es-selectCountry__country_name_en">{{ ' (' + keyItem.country_code + ', ' + keyItem.country_name_en + ')'}}</div></div><div v-if="(keyItem.isSelected)"><es-icon name="check-filled" :size="(18)" color="#1473ff"/></div></mpx-view></div><div class="es-selectCountry__noResult" v-if="(isSearch && !hasRes && !isLoading)"><div :style='["height:180px"] | transRpxStyle'></div>暂无匹配结果</div></div><div class="select_country_footer" v-if="(!(isSearch && !hasRes && !isLoading))"></div></es-layout></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m1bd4bb44"}'>
  +b('selectCountry')
    +e('keyString')
      display flex
      align-items center
      padding-left 12px
      height 30px
      background-color #F3F4F5
      color #333333
      font-size 14px
    +e('list')
      background-color #FFFFFF
      // width 100%
      // height 100%
    +e('list-item')
      display flex
      justify-content space-between
      position relative
      align-items center
      margin 0 36px 0 12px
      padding-right 5px
      height 44px
      background #FFFFFF
      &::after
          content " "
          position absolute
          left 0
          bottom 0
          width 100%
          height 1px
          background #eeeeee
          transform scaleY(0.5)

    +e('tabView')
      position fixed 
      z-index 1
      height calc(100% - 156px)
      right 0px
      overflow scroll
    +e('tab')
      font-size 12px
      min-height 416px
      background: #FFFFFF
      padding-top 12px
      color #999999
      text-align center
    +e('tabItem')
      line-height 16px
      padding 0 12px
    +e('active')
      color #1473ff
    +e('noResult')
      font-family PingFangSC-Regular
      font-size 14px
      color #999999
      background #ffffff
      text-align center
      // padding-top 180px
    +e('country_name')
      display flex
      align-items center
      flex-wrap wrap
    +e('country_name_cn')
      font-size 14px
    +e('country_name_en')
      font-size 12px
    
    
  .custom-main
    background: #FFFFFF !important
  /deep/ .custom-main
    background: #ffffff !important
  .custom-navbar
    background: #FFFFFF !important
  /deep/ .custom-navbar
    background: #ffffff !important
  .select_country_footer
    background: #ffffff
    height 44px
    width 100%

</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m1bd4bb44"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./selectCountry.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./selectCountry.mpx?ctorType=page&index=0&isPage&mpx&type=script")
  const currentOption = global.__mpxOptionsMap["m1bd4bb44"]
  export default processOption(
    currentOption,
    "page",
    "",
    "",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-icon':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex")),'search-input':getComponent(require("./components/search-input/index.mpx?isComponent&outputPath=components%2Findexdee11fea%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
